// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"111":"6cafd6fc","896":"08d74cc8"}[chunkId] + ".js";
};